import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '@environments/environment';
import { forkJoin } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class LangService {
  private readonly http = inject(HttpClient);

  loadLangs(langOptions: string[] | string | object) {
    const aliases = [];
    // aliases can handle 3 format:
    // - string: alias: 'app'
    // - array of string: alias: ['app', 'common', 'settings]
    // - array of object: alias: [{name: 'app', locale: 'fr'},{name: 'common', locale: 'fr-FR'}]
    if (typeof langOptions['aliases'] === 'object') {
      langOptions['aliases'].forEach((alias) => {
        // if we have an object which define the name and the locale of the file
        if (
          Object.prototype.hasOwnProperty.call(alias, 'name') &&
          Object.prototype.hasOwnProperty.call(alias, 'locale')
        ) {
          aliases.push({
            name: alias.name,
            locale: alias.locale,
          });
        } else {
          // if we have an object of string with only the name of the file, set the locale to the default
          aliases.push({
            name: alias,
            locale: langOptions['locale'],
          });
        }
      });
    } else if (typeof langOptions['aliases'] === 'string') {
      // if we have a string, set it to the name and the locale to the default
      aliases.push({
        name: langOptions['aliases'],
        locale: langOptions['locale'],
      });
    }

    const options = {
      baseUrl: environment.langsUrl,
      aliases,
      locale: langOptions['locale'],
    };

    const langs$ = [];
    options.aliases.forEach((alias) => {
      langs$.push(this.http.get(`${options.baseUrl}${alias.locale}/${alias.name}.json?v=1`));
    });

    return forkJoin(langs$).pipe(
      map((langs) =>
        langs.reduce(
          (acc: Record<string, string>, currLang, index) => ({
            ...acc,
            [options.aliases[index].name]: currLang,
          }),
          {},
        ),
      ),
    );
  }
}
